module.exports = __webpack_public_path__ + "assets/6c17efc1fc11f9ebbd7d25b4d5948f74.jpg";